import { Form, Space, TableProps } from 'antd';
import { EditIcon } from 'assets/svg';
import { ButtonAction, InputForm } from 'components';
import InputNumberForm from 'components/Input/InputNumberForn';
import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import React, { forwardRef, useImperativeHandle } from 'react';
import { bonusConditions } from 'utils/constants/constant';
import formatNumber, {
  formatDate,
  generateUUID,
} from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';
import { HocChangePagination } from 'utils/HocChangePagination';

interface IProps extends React.PropsWithChildren<TableProps> {
  disabledEdit: boolean;
  data: any;
  onSave: () => void;
  onCancel: () => void;
  onEdit: (data: any) => void;
  indexHandle: number;
  // setIndexHandle: (value: number) => void;
  // isAdd: boolean;
  form: any;
  refetch: (isExport?: boolean, headerRow?: any) => void;
}
const { SaveTwoTone, CloseCircleTwoTone } = icons;
const TableRewardCalculation = forwardRef((props: IProps, ref: any) => {
  const {
    disabledEdit,
    data = {},
    loading,
    refetch,
    onSave,
    onCancel,
    onEdit,
    indexHandle,
    // isAdd,
    form,
  } = props;

  const handleChange = () => {
    const item = data?.items[indexHandle];

    form.setFieldValue(
      'totalExpenEndPeriod',
      item.totalExpenEndPeriod +
        (form.getFieldValue('rewardLastMonth') || 0) +
        (form.getFieldValue('hotRewardAmount') || 0) -
        item.rewardLastMonth -
        item.hotRewardAmount,
    );
  };

  const columns: ColumnsTypeCustom = [
    {
      fixed: 'left',
      title: 'STT',
      width: 50,
      align: 'center',
      render: (_, __, index) =>
        data?.pageInfo?.itemsPerPage * (data?.pageInfo?.currentPage - 1) +
        index +
        1,
      // index + 1,
    },
    {
      fixed: 'left',
      title: 'Chi nhánh',
      width: 100,
      dataIndex: 'plantId',
      render(value, record, index) {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'plantId'} className="m-0">
        //       <SelectForm placeholder="Chọn chi nhánh" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      fixed: 'left',
      title: 'Họ và tên',
      width: 160,
      dataIndex: 'userRewardName',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'userRewardName'} className="m-0">
        //       <SelectForm placeholder="" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      fixed: 'left',
      title: 'Loại doanh thu',
      width: 180,
      dataIndex: ['trewardSetup', 'ttype', 'name'],
      // render: (value) =>
      //   value ? bonusConditions[value as keyof typeof bonusConditions] : '-',
    },
    {
      title: 'Mã nhân viên',
      width: 130,
      dataIndex: 'userRewardId',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'userRewardId'} className="m-0">
        //       <SelectForm placeholder="" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Mã chức vụ',
      width: 120,
      dataIndex: 'jobTitleCode',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'jobTitleCode'} className="m-0">
        //       <SelectForm placeholder="" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },

    {
      title: 'Chức vụ',
      width: 230,
      dataIndex: 'jobTitleName',
      render(value, record, index) {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'jobTitleName'} className="m-0">
        //       <SelectForm placeholder="Chọn chức vụ" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Nhóm',
      width: 100,
      dataIndex: 'groupId',
      render(value, record, index) {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'groupId'} className="m-0">
        //       <SelectForm placeholder="Chọn nhóm" size="middle" />
        //     </Form.Item>
        //   );
        return typeof value === 'string'
          ? value === 'gp001'
            ? 'Nhóm 1'
            : 'Nhóm 2'
          : '-';
      },
    },
    {
      title: 'Đối tượng',
      width: 100,
      dataIndex: ['objectType'],
      render(value, record, index) {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'objectType'} className="m-0">
        //       <SelectForm placeholder="Chọn đối tượng" size="middle" />
        //     </Form.Item>
        //   );
        return value ? 'Trực tiếp' : 'Gián tiếp';
      },
    },
    {
      title: 'Ngày ký HĐLĐ',
      width: 150,
      dataIndex: 'signDate',
      type: 'date',
      render: (value) => formatDate(value, 'DD/MM/YYYY'),
    },
    {
      title: 'Ngày giao chỉ tiêu',
      width: 160,
      dataIndex: 'kpiDate',
      type: 'date',
      render: (value) => formatDate(value, 'DD/MM/YYYY'),
    },
    {
      title: 'Tháng',
      width: 60,
      dataIndex: 'monthReward',
      align: 'right',
      render: (value, record) =>
        value ? `${value}/${record?.yearReward}` : '-',
    },
    {
      title: 'Kế hoạch',
      width: 180,
      dataIndex: 'planAmount',
      align: 'right',
      render: (value) => (value ? formatNumber(value) : '-'),
    },
    {
      title: 'Thực hiện',
      width: 180,
      align: 'right',
      dataIndex: 'actualAmount',
      render: (value) => (value ? formatNumber(value) : '-'),
    },
    {
      title: 'Tỷ lệ (%)',
      width: 120,
      align: 'right',
      dataIndex: 'percentPlanVsActual',
      render: (value, record) => (
        <span
          className={
            record.actualAmount && record.actualAmount < record.rewardSeqment_1
              ? 'text-red-500'
              : ''
          }
        >
          {formatNumber(value)}
        </span>
      ),
    },
    {
      title: 'Khung thưởng 1',
      width: 130,
      dataIndex: 'rewardSeqment_1',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Khung thưởng 2',
      width: 130,
      dataIndex: 'rewardSeqment_2',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Khung thưởng 3',
      width: 130,
      dataIndex: 'rewardSeqment_3',
      align: 'right',
      render: (value) => formatNumber(value),
    },

    {
      title: 'Khung thưởng 4',
      width: 130,
      dataIndex: 'rewardSeqment_4',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Thưởng khung 1',
      width: 250,
      dataIndex: 'rewardSeqmentAmount_1',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Thưởng khung 2',
      width: 130,
      dataIndex: 'rewardSeqmentAmount_2',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Thưởng khung 3',
      width: 130,
      dataIndex: 'rewardSeqmentAmount_3',
      align: 'right',
      render: (value) => formatNumber(value),
    },

    {
      title: 'Thưởng khung 4',
      width: 130,
      dataIndex: 'rewardSeqmentAmount_4',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Tổng thưởng',
      width: 130,
      dataIndex: 'totalReward',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: 'Bổ sung tháng trước',
      width: 160,
      dataIndex: 'rewardLastMonth',
      align: 'right',
      render: (value, _, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'rewardLastMonth'} className="m-0">
              <InputNumberForm
                placeholder="Nhập bổ sung tháng trước"
                size="middle"
                precision={0}
                onChange={handleChange}
              />
            </Form.Item>
          );

        return formatNumber(value);
      },
    },
    {
      title: 'Thưởng nóng',
      width: 160,
      dataIndex: 'hotRewardAmount',
      align: 'right',
      render: (value, _, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'hotRewardAmount'} className="m-0">
              <InputNumberForm
                placeholder="Nhập thưởng nóng"
                size="middle"
                min={0}
                precision={0}
                onChange={handleChange}
              />
            </Form.Item>
          );

        return formatNumber(value);
      },
    },
    {
      title: 'Tổng chi cuối kỳ',
      width: 135,
      dataIndex: 'totalExpenEndPeriod',
      align: 'right',
      render: (value, _, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'totalExpenEndPeriod'} className="m-0">
              <InputNumberForm
                readOnly
                disabled
                placeholder="Nhập tổng chi cuối kỳ"
                size="middle"
              />
            </Form.Item>
          );

        return formatNumber(value);
      },
    },
    {
      title: 'Đơn vị tiền',
      width: 110,
      dataIndex: '',
      align: 'right',
      render: () => 'VNĐ',
    },
    {
      title: 'Ghi chú',
      width: 200,
      dataIndex: 'note',
      render: (value, _, index) => {
        if (indexHandle === index)
          return (
            <Form.Item name={'note'} className="m-0">
              <InputForm placeholder="Nhập ghi chú" size="middle" />
            </Form.Item>
          );
        return value;
      },
    },
    {
      title: 'Mã thưởng DMS',
      width: 130,
      dataIndex: 'groupRoleManagementId',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'groupRoleManagementId'} className="m-0">
        //       <SelectForm placeholder="" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Mã điều kiện',
      width: 130,
      dataIndex: 'rewardSetupId',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'rewardSetupId'} className="m-0">
        //       <SelectForm placeholder="" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Đơn vị',
      width: 160,
      dataIndex: 'plantName',
    },
    {
      title: 'Người khai báo',
      width: 130,
      dataIndex: ['tcreateUser', 'fullName'],
    },
    {
      title: 'Ngày khai báo',
      width: 170,
      dataIndex: 'createDate',
      render: (text) => formatDate(text),
    },
    {
      title: 'Người cập nhật',
      width: 130,
      dataIndex: ['tmodifyUser', 'fullName'],
    },
    {
      title: 'Ngày cập nhật',
      width: 170,
      dataIndex: 'modifyDate',
      render: (text) => formatDate(text),
    },
    {
      fixed: 'right',
      align: 'center',
      width: 70,
      render: (__, record, index) =>
        index === indexHandle ? (
          <Space size={'middle'} className="text-lg">
            <ButtonAction tooltip="Lưu" onClick={onSave}>
              <SaveTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
            <ButtonAction tooltip="Hủy" onClick={onCancel}>
              <CloseCircleTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
          </Space>
        ) : (
          <Space size={'middle'} className="text-lg ">
            <ButtonAction
              tooltip="Chỉnh sửa"
              onClick={() => onEdit(index)}
              disabled={disabledEdit}
            >
              <EditIcon />
            </ButtonAction>
          </Space>
        ),
    },
  ];

  useImperativeHandle(ref, () => ({
    exportExcel,
  }));

  const exportExcel = () => {
    // Danh sách các cột có dataIndex là string cần loại bỏ
    const excludedStringDataIndexes: string[] = [
      'jobTitleCode', // Mã chức vụ
      'groupId', // Nhóm
      'kpiDate', // Ngày giao chỉ tiêu
      'groupRoleManagementId', // Mã thưởng DMS
      'rewardSetupId', // Mã điều kiện
      'plantName', // Đơn vị
      'createDate', // Ngày khai báo
      'modifyDate', // Ngày cập nhật
    ];

    // Danh sách các cột có dataIndex là array cần loại bỏ
    const excludedArrayDataIndexes: string[][] = [
      ['objectType'], // Đối tượng
      ['tcreateUser', 'fullName'], // Người khai báo
      ['tmodifyUser', 'fullName'], // Người cập nhật
    ];

    // Hàm so sánh hai array có bằng nhau không
    const arraysEqual = (arr1: string[], arr2: string[]): boolean => {
      return (
        arr1.length === arr2.length &&
        arr1.every((val, idx) => val === arr2[idx])
      );
    };

    // Hàm kiểm tra xem column có nên bị loại bỏ không
    const shouldExcludeColumn = (column: any) => {
      const dataIndex = column.dataIndex;

      // Kiểm tra nếu dataIndex là array
      if (Array.isArray(dataIndex)) {
        return excludedArrayDataIndexes.some((excluded) =>
          arraysEqual(dataIndex, excluded),
        );
      }

      // Kiểm tra nếu dataIndex là string
      return excludedStringDataIndexes.includes(dataIndex);
    };

    // Lọc bỏ các cột không cần thiết
    const filteredColumns = columns.filter(
      (column) => !shouldExcludeColumn(column),
    );

    // Tìm cột "Mã nhân viên" và đưa lên đầu tiên
    const userRewardIdColumnIndex = filteredColumns.findIndex(
      (col: any) => col.dataIndex === 'userRewardId',
    );

    if (userRewardIdColumnIndex > 0) {
      // Lấy cột "Mã nhân viên" ra
      const userRewardIdColumn = filteredColumns[userRewardIdColumnIndex];
      // Xóa cột đó khỏi vị trí cũ
      filteredColumns.splice(userRewardIdColumnIndex, 1);
      // Chèn vào đầu danh sách (sau STT nếu có, nhưng STT sẽ được thêm bởi exportExcel_v2)
      filteredColumns.unshift(userRewardIdColumn);
    }

    // Cập nhật cột "Tỷ lệ %" để thêm dấu % vào sau giá trị khi export
    const percentColumnIndex = filteredColumns.findIndex(
      (col: any) => col.dataIndex === 'percentPlanVsActual',
    );

    if (percentColumnIndex >= 0) {
      const percentColumn = filteredColumns[percentColumnIndex];
      // Tạo bản copy với render function mới để thêm dấu %
      filteredColumns[percentColumnIndex] = {
        ...percentColumn,
        isShowRender: true,
        render: (value: any) => {
          if (value === null || value === undefined || value === '') {
            return '-';
          }
          return `${formatNumber(value)}%`;
        },
      };
    }

    // Danh sách các cột số cần format đúng định dạng trong Excel
    const numericColumns = [
      'planAmount', // Kế hoạch
      'actualAmount', // Thực hiện
      'rewardSeqment_1', // Khung thưởng 1
      'rewardSeqment_2', // Khung thưởng 2
      'rewardSeqment_3', // Khung thưởng 3
      'rewardSeqment_4', // Khung thưởng 4
      'rewardSeqmentAmount_1', // Thưởng khung 1
      'rewardSeqmentAmount_2', // Thưởng khung 2
      'rewardSeqmentAmount_3', // Thưởng khung 3
      'rewardSeqmentAmount_4', // Thưởng khung 4
      'totalReward', // Tổng thưởng
      'rewardLastMonth', // Bổ sung tháng trước
      'hotRewardAmount', // Thưởng nóng
      'totalExpenEndPeriod', // Tổng chi cuối kỳ
    ];

    // Cập nhật format cho các cột số - sử dụng type: 'number' với unit để Excel tự format với dấu phẩy
    filteredColumns.forEach((col: any, index: number) => {
      if (col.dataIndex && numericColumns.includes(col.dataIndex)) {
        filteredColumns[index] = {
          ...col,
          type: 'number',
          unit: 1, // Cần có unit để Excel format với #,##0 (dấu phẩy ngăn cách hàng nghìn)
          // Không set isShowRender để Excel sử dụng logic format mặc định với type: 'number'
          isShowRender: false,
        };
      }
    });

    refetch(true, filteredColumns);
  };

  return (
    <Content>
      <Form form={form}>
        <TableComponent
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={data?.items || []}
          // dataSource={data.items}
          rowKey={(record: any) => record?.id || generateUUID()}
          loading={loading}
          pagination={{
            disabled:
              // isAdd ||
              indexHandle !== -1,
            current: data?.pageInfo?.currentPage,
            pageSize: data?.pageInfo?.itemsPerPage,
            total: data?.pageInfo?.totalItems,
            onChange: HocChangePagination(),
          }}
        />
      </Form>
    </Content>
  );
});

export default TableRewardCalculation;
